module.exports = __webpack_public_path__ + "img/transport03.42178f49.png";